'use client'

import { Media } from '@/payload-types'
import React from 'react'
import { Label } from '@/components/ui/label'
import { AuthorAvatar } from './AuthorAvatar'
import { cn } from '@/utilities/ui'

export const AuthorGroup: React.FC<{
  className?: string
  authors: { id: string; name: string; avatar: Media }[]
  size?: 24 | 20 | 16
}> = ({ authors, size = 20, className }) => {
  // Join with commas and 'and' for the last author
  const names = authors.map((author, index) => {
    if (authors.length > 1 && index === authors.length - 1) {
      return ` and ${author.name}`
    }
    return author.name
  })
  return (
    <div className={cn('flex flex-row flex-wrap gap-[10px] items-center', className)}>
      <div className="flex flex-row gap-[6px]">
        {authors?.map((author) => <AuthorAvatar key={author.id} author={author} size={size} />)}
      </div>
      <Label className="text-[18px] font-medium">
        By <Label className="text-[18px] font-medium text-punch">{names}</Label>
      </Label>
    </div>
  )
}
